import { render, staticRenderFns } from "./PreviewsDropdown.vue?vue&type=template&id=5f76dc7c"
import script from "./PreviewsDropdown.vue?vue&type=script&lang=js"
export * from "./PreviewsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f76dc7c')) {
      api.createRecord('5f76dc7c', component.options)
    } else {
      api.reload('5f76dc7c', component.options)
    }
    module.hot.accept("./PreviewsDropdown.vue?vue&type=template&id=5f76dc7c", function () {
      api.rerender('5f76dc7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/PreviewsDropdown.vue"
export default component.exports